import React, { Fragment } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import Image from 'react-bootstrap/Image';
import { addCategoryAction } from '../../redux/actions';
import Footer from '../LayOut/Footer';
import Header from '../LayOut/Header';
import { processText } from './../Extras';

const imageStyle2 = (image) => ({	
  height: '100%',
  width: '100%',
  borderRadius: '10px',
  position: 'absolute',
  top:0,
  left: 0,
  filter: image === '' ? 'brightness(0%)' : 'brightness(50%)'
});

const categoryTextStyle = (image) => ({	
  borderRadius: 20,
  fontSize: 20,
  zIndex: 3,
  color: 'white',
  fontFamily: 'nunito',
  fontWeight: 'bold',
  height: '100%',
  width: '100%',
  textAlign: 'center',
});

class category extends React.Component {
  state = {
    categories: [],
    loaded: false,
  };

  async componentDidMount() {
    let { data } = this.props;
    let categories = [];

    data.forEach((cat) => {
      categories.push(cat.category);
    });

    this.setState({
      categories,
      loaded: true
    });
  }

  displayCategories = () => (
    <div  style={{ paddingBottom: '70px' }}>
      <div className="row mx-1">
        {this.state.categories.map((category, index) => {
          return (
            <div 
              key={index}
              className="my-2 col-6 p-0 d-flex justify-content-center"	
              style={{height:'20vh'}}
            >	
              <div
                className="d-flex align-items-center justify-content-center"
                style={{height:'100%', width:'90%', position:'relative'}}
              >	
                <Image src={category.image === '' ? require('../../images/white.png') : category.image} style={imageStyle2(category.image)} alt='...' />
                <Link
                  to={`products/${category.name}`}
                  onClick={() => this.props.addCategory(category.name)}
                  style={{height:'100%', width:'100%', display:'flex', 
                  alignItems:'center', justifyContent:'center'}} 
                >  
                  <div
                    className="d-flex align-items-center justify-content-center" 
                    style={categoryTextStyle(category.image)}
                  >
                    {processText(category.name)}
                  </div>
                </Link>

              </div>	
            </div>
          );
        })}
      </div>
    </div>
  );

  render() {
    let url = this.props.location.pathname.split('/')[1];
    if(this.props.data.length === 0 || url !== this.props.userName){
      return <Redirect to={{ pathname: `/${url}` }} />;
    }

    return (
      <Fragment>	
        <Header />
        <div className="col-md-3 offset-md-4" style={{marginTop: '0'}}>
          {this.displayCategories()}
        </div>
        <Footer />
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  props: ownProps,
  userName: state.userName,
  data: state.data,
});

const mapDispatchToProps = (dispatch) => ({
  addCategory(food) {
    dispatch(addCategoryAction(food));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(category);
